export enum SortCompareResult {
  LESS = 1,
  GREATER = -1,
  EQUAL = 0,
}
